import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Tags from '../../../../Tags';
import FoldableTagList from '../../../../FoldableTagList';
import s from './JournalTags.scss';
export var JournalTags = function (_a) {
    var tags = _a.tags;
    var devpage_tags_update = useFlag('devpage_tags_update');
    return tags ? (React.createElement("div", { className: s['tags'] }, devpage_tags_update ? (React.createElement(FoldableTagList, { tags: tags })) : (React.createElement(Tags, { tags: tags })))) : null;
};
JournalTags.displayName = 'JournalTags';
export default JournalTags;
//# sourceMappingURL=JournalTags.js.map